export default __webpack_public_path__ + "static/media/kanipakam.4f0aa362.png";